import request from '@/utils/request'

export function getJobs() {
  return request({
    url: '/jobManage/list?releaseStatus=0',
    method: 'get'
  })
}